var m = require('mithril');
var domSlider = require('../utils/dom-slider')
var Table = require('./Table');
var Row = require('./TableRow');
var { state } = require('../state');

var SlideDown = {
    oncreate: ({ attrs: { down }, dom, state }) => {
        if (!down) domSlider.slideUp({
            element: dom,
            slideSpeed: 0
        })
        state.down = down;
    },
    onupdate: ({ attrs, state, dom }) => {
        if (attrs.down !== state.down) {
            if (attrs.down) {
                domSlider.slideDown({
                    element: dom,
                    slideSpeed: 400
                })
            } else {
                domSlider.slideUp({
                    element: dom,
                    slideSpeed: 400
                })
            }
            state.down = attrs.down;
        }
    },
    view: ({ children }) => children
}

module.exports = {
    aboutVisible: false,
    toggleAbout: ({ state }) => state.aboutVisible = !state.aboutVisible,
    init: vnode => vnode.state.toggleAbout = state.toggleAbout.bind(state, vnode),
    view: vnode => {
        var { contact, about } = state.data;
        return m(Table,
            contact.map(row => m(Row, row)),
            m(Row, { label: 'About', text: vnode.state.aboutVisible ? '-' : '+', onclick: () => vnode.state.aboutVisible = !vnode.state.aboutVisible }),
            m(SlideDown, { down: vnode.state.aboutVisible },
                m('.about',
                    m.trust(about)
                )
            )
        )
    }
}


// WEBPACK FOOTER //
// ./js/components/Contact.js